import Model, { attr, belongsTo } from '@ember-data/model';

import OrganizationValidations from 'register-partners-js/validations/organization';

export default class Organization extends Model.extend(OrganizationValidations) {
  @attr('string') createdAt;
  @attr legalCountry;
  @attr legalName;
  @attr legalForm;
  @attr natureOfOperations;
  @attr features;
  @attr('string') yearlyTransactionVolume;
  @attr('number') maxSinglePaymentAmount;
  @attr('string', { allowNull: true, defaultValue: null }) businessActivityEntityType;
  @attr('boolean', { allowNull: true, defaultValue: null }) declaredPepInBeneficiaries;

  @belongsTo('stakeholder', { async: false, inverse: 'organization' }) stakeholder;
  @belongsTo('registration', { async: false, inverse: 'organization' }) registration;
}
